// Layout.js
import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../Navbar/navbar";
import Landing from "../pages/Landing";

const Layout = () => {
  return (
    <div>
      <Navbar />
      <main>
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
